/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{LayerViewPerformanceInfo as t}from"./support/LayerViewPerformanceInfo.js";class e extends t{constructor(t,e,r,s,o,i,p){super(t,0,0,0,e),this.gpuMB=r,this.geometryMB=s,this.textureMB=o,this.unloadedMB=i,this.idbHitRate=p}}export{e as I3SMeshViewPerformanceInfo};
